import { useEffect, useState } from 'react'
import useAppStore from '../../../../stores/app'

const Timer = () => {
  const updateSocketVersion = useAppStore(state => state.updateSocketVersion)
  const [seconds, setSeconds] = useState(300)

  useEffect(() => {
    const startTime = Date.now()
    const timer = setInterval(() => {
      const currentTime = Date.now()
      const elapsedTime = Math.floor((currentTime - startTime) / 1000)
      const remainingSeconds = Math.max(0, 300 - elapsedTime)
      setSeconds(remainingSeconds)
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  const padStart = (value: number | string, targetLength: number, padChar: string | number = '0'): string => {
    const valueStr = String(value)
    if (valueStr.length >= targetLength) {
      return valueStr
    }
    return String(padChar).repeat(targetLength - valueStr.length) + valueStr
  }

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60)
    const seconds = time % 60
    return `${minutes}:${padStart(seconds, 2, '0')}`
  }

  if (seconds === 0) {
    updateSocketVersion() // Update to current version before reload
    window.location.reload()
  }

  return (
    <div>{formatTime(seconds)}</div>
  )
}

export default Timer

